import React from "react";
import {
  FaArrowLeft,
  FaExclamationTriangle,
  FaHome,
  FaRedoAlt,
} from "react-icons/fa";
import { useTranslation } from "react-i18next";

const ErrorPage = ({ code }) => {
  const { t } = useTranslation();
  const isNotFound = code === 404;

  const handlePrimaryAction = () => {
    if (isNotFound) {
      window.location.assign("/");
      return;
    }

    window.location.reload();
  };

  const handleBack = () => {
    if (window.history.length > 1) {
      window.history.back();
      return;
    }

    window.location.assign("/");
  };

  return (
    <main
      className={`error-page error-page--${code}`}
      aria-labelledby="error-page-title"
    >
      <div className="error-page__decoration" aria-hidden="true" />

      <section className="error-page__card">
        <a className="error-page__brand" href="/" aria-label="AzTruck">
          <img src="/images/logo.svg" alt="" />
        </a>

        <div className="error-page__icon" aria-hidden="true">
          <FaExclamationTriangle />
        </div>

        <p className="error-page__code">{t("errorPage.code", { code })}</p>
        <h1 id="error-page-title">
          {t(isNotFound ? "errorPage.notFoundTitle" : "errorPage.errorTitle")}
        </h1>
        <p className="error-page__description">
          {t(
            isNotFound
              ? "errorPage.notFoundDescription"
              : "errorPage.errorDescription"
          )}
        </p>

        <div className="error-page__actions">
          <button
            className="error-page__button error-page__button--primary"
            type="button"
            onClick={handlePrimaryAction}
          >
            {isNotFound ? <FaHome /> : <FaRedoAlt />}
            <span>
              {t(isNotFound ? "errorPage.home" : "errorPage.tryAgain")}
            </span>
          </button>

          {isNotFound ? (
            <button
              className="error-page__button error-page__button--secondary"
              type="button"
              onClick={handleBack}
            >
              <FaArrowLeft />
              <span>{t("errorPage.back")}</span>
            </button>
          ) : (
            <a
              className="error-page__button error-page__button--secondary"
              href="/"
            >
              <FaHome />
              <span>{t("errorPage.home")}</span>
            </a>
          )}
        </div>

        {!isNotFound && (
          <p className="error-page__help">{t("errorPage.help")}</p>
        )}
      </section>
    </main>
  );
};

export default ErrorPage;
